module.exports = __webpack_public_path__ + "static/media/bullet.7c1a2e39.png";